import React, { createContext, useEffect, useRef, useState } from "react";
import { fork } from "redux-saga/effects";

import I18nInit from "./I18nInit";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { useDispatch, useSelector } from "react-redux";
import { get_maps } from "stores/API/actions";

import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";

import { combineReducers } from "redux";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";

import reducersAPI from "stores/API/reducers";
import reducersAccounts from "stores/Accounts/reducers";
import reducersService from "stores/Service/reducers";

import sagasAPI from "stores/API/sagas";
import sagasAccounts from "stores/Accounts/sagas";
import sagasService from "stores/Service/sagas";
import socketIOClient from "socket.io-client";
import env from "../stores/env";
function* rootSaga() {
  yield fork(sagasAPI);
  yield fork(sagasAccounts);
  yield fork(sagasService);
}
const rootReducer = combineReducers({
  ...reducersAPI,
  ...reducersService,
  ...reducersAccounts,
});

// 永続化の設定
const persistConfig = {
  key: "redux", // Storageに保存されるキー名を指定する
  storage: sessionStorage, // 保存先としてlocalStorageがここで設定される
  // whitelist: ['reduce_get_maps', 'reduce_post_authin', 'reduce_post_notification'],

  // Stateは`todos`のみStorageに保存する
  blacklist: ["reduce_variable"], // `visibilityFilter`は保存しない
};

const rootReducer2 = (state, action) => {
  if (action.type === "POST_AUTHOUT") {
    // state = undefined
    const newState = Object.assign({}, state, {});

    for (var key in newState) {
      if (key === "reduce_get_maps") {
        newState[key].isLoading = newState[key].isLoading;
      } else {
        if (key.startsWith("reduce_get_")) {
          newState[key] = { isLoading: true };
        }else{
          newState[key] = { isLoading: false };
        }
      }
    }

    return rootReducer(newState, action);
  }

  return rootReducer(state, action);
};

// 永続化設定されたReducerとして定義
const persistedReducer = persistReducer(persistConfig, rootReducer2);

const sagaMiddleware = createSagaMiddleware();

const store = createStore(persistedReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);

export const AppStore = () => {
  // let socket = null;

  // useEffect(() => {
  //   socket = socketIOClient(env.REACT_APP_SOCKET_URL, {
  //     reconnection: true,
  //     rejectUnauthorized: false,
  //     // path: '/socket/markets'
  //   });

  //   socket.on("connect", () => {
  //     alert("connect")
  //   });

  //   socket.on("markets", () => {
  //     alert("markets")
  //   });

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppLoading />
      </PersistGate>
    </Provider>
  );
};

const AppLoading = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      get_maps({
        data: {},
        toast: () => {},
        page: () => {},
      })
    );
  }, []);

  const reduce_get_maps = useSelector((state) => state.reduce_get_maps);

  if (reduce_get_maps.isLoading) {
    return <></>;
  }
  return <I18nInit />;
};
